import { ShieldCheck } from 'lucide-react';

export const AdminLogin = ({ error, onLogin }) => (
  <main className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-6" data-testid="admin-login-page">
    <section className="w-full max-w-md border border-slate-800 bg-slate-900 rounded-2xl p-8 shadow-2xl">
      <div className="w-12 h-12 rounded-xl bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center mb-6">
        <ShieldCheck className="text-emerald-400" size={24} aria-hidden="true" />
      </div>
      <p className="text-xs font-semibold tracking-[0.2em] uppercase text-emerald-400 mb-3">Restricted access</p>
      <h1 className="text-4xl font-black tracking-tight mb-3">Admin downloads</h1>
      <p className="text-slate-400 leading-relaxed mb-7">
        Sign in with an approved Google account to access TweePorter module packages.
      </p>
      {error && (
        <div className="mb-5 rounded-lg border border-red-800 bg-red-950/40 px-4 py-3 text-sm text-red-300" data-testid="admin-login-error">
          {error}
        </div>
      )}
      <button
        type="button"
        onClick={onLogin}
        data-testid="admin-google-login-button"
        className="w-full rounded-xl bg-white text-slate-950 px-5 py-3 font-semibold hover:bg-emerald-50 active:translate-y-px transition-[background-color,transform]"
      >
        Continue with Google
      </button>
      <a href="/" data-testid="admin-back-home-link" className="block text-center text-sm text-slate-500 hover:text-slate-300 mt-5 transition-colors">
        Return to TweePorter
      </a>
    </section>
  </main>
);
